<template>
    <div>
         <Breadcrumb :headers="headers"></Breadcrumb>
        <List
            url="getFileCertifications" :tanle="tanle" :update="updateList" 
            :operat="operat"  :isAdd="false" 
            :data="resultData" @download="download" @download2="download2">

           <div slot="Filter">
                <label style="margin-left:10px;">Product Category：</label>
                <el-select style="width:150px;" v-model="searchData.ProductCategory"  @change="searchData.ProductModel ='all'" placeholder="">
                    <el-option
                        v-for="item in productCategoryList"
                        :key="item.ID"
                        :label="item.ProductCategory"
                        :value="item.ID">
                    </el-option>
                </el-select>

                <label style="margin-left:10px;">Product Model：</label>
                <template>
                
                    <el-select style="width:150px;" v-model="searchData.ProductModel" placeholder="">
                        <el-option
                            v-for="item in productModelList"
                            :key="item.ID"
                            :label="item.ProductModel"
                            :value="item.ID">
                        </el-option>
                    </el-select>
               
                </template>

                <label style="margin-left:10px;">Document Type：</label>
                    <el-select style="width:140px;"   v-model="searchData.DocumentType" placeholder=""  @change="isCertification">
                        <el-option
                            v-for="item in documentTypeList"
                            :key="item.ID"
                            :label="item.DocumentType"
                            :value="item.ID"
                        >
                        </el-option>
                    </el-select>
                    <el-select  v-if="isCertificationBlock"  v-model="searchData.Certification"   style="width:200px;margin-left:10px" placeholder=""  >
                        <el-option
                            v-for="item in certificationList"
                            :key="item.ID"
                            :label="item.Name"
                            :value="item.ID"
                        >
                        </el-option>
                    </el-select>
                    <el-button @click="result" type="primary" style="margin-left:10px;">Search</el-button>
            </div>
        </List>
    <iframe id="ifile" name="ifile" :src="iframeUrl" style="display:none"></iframe>
    </div>
</template>

<script>
import List from "../components/common/List.vue";
import Breadcrumb from "../components/common/Breadcrumb.vue";
import { certificationList } from "@/components/Certifications/data.js";

import { unshiftAll } from "@/methods/selection.js";
export default {
    components:{
        List,
        Breadcrumb
    },
    data () {
        return {
            tanle:[{name:"Name",label:"File Name",type:"file",width:'500px'},{name:"DocumentTypeName",label:"Document Type",width:'250px'},{name:"PublishTime",label:"Last Updated"},{name:"Size",label:"Size"}],
            updateList:0,
            updateBlock:false,
            updateForm:{},
            headers:[{label:"Home",path:"/dashboard"},{label:"Product Documents",path:"/certifications"}],
            iframeUrl:"",
            searchData:{
                Key:"",
                ProductCategory:"all",
                ProductModel:"all",
                DocumentType:"all",
                Certification:"all"
            },
            resultData:{
                Key:"",
                ProductCategory:"all",
                ProductModel:"all",
                DocumentType:"all"
            },
            isCertificationBlock:false,
            productCategoryList:"",
            productModelList:"",
            documentTypeList:"",
            certificationList:[],
            operat: [{
                text: "Download",
                eventName: "download2",
                type: "primary"
            }]
        };
    },
    created () {},
    mounted () {
        this.$http.get("getAllDocumentsProductCategory",{},(data)=>{
            this.productCategoryList = data.data;
            this.productCategoryList.unshift({ProductCategory:"all"});
        });
        this.$http.get("getDocumentsProductModel",{},(data)=>{
            this.productModelList = data.data;
            this.productModelList.unshift({ProductModel:"all"});
        });
        this.$http.get("getAllDocumentsDocumentType",{},(data)=>{
            this.documentTypeList = data.data;
            this.documentTypeList.unshift({DocumentType:"all"});
        });
        this.$http.get("getChildOfDocumentType",{pid:3},(resp)=>{
            if (resp.code == 0) {
                let data = resp.data
                let certificationListTemp = [];
                if (data.length > 0) {
                    data.forEach(item => {
                        let dataListTemp = {}
                        dataListTemp.ID = item.ID;
                        dataListTemp.Name = item.DocumentType;
                        certificationListTemp.push(dataListTemp);
                    });
                    this.certificationList = certificationListTemp;
                }
            }
        });
    },
    methods:{
        // dealListData (data) {
        //     for(let i in data) {
        //         data[i].DocumentTypeName = DocumentType[data[i].DocumentType];
        //     }
        //     return data;
        // },
        download2 (data) {
            this.download(data.Name);
        },
        download (data) {
            this.iframeUrl = `${this.$http.host}akuvoxwiki/download/partnerManage/productMaterials/${data}`;
              
        },
        isCertification () {
            if(this.searchData.DocumentType === '3') {
                this.searchData.Certification = 'all',
                this.isCertificationBlock = true;
            } 
            else
                this.isCertificationBlock = false;
        },
        result () {
            this.resultData.ProductCategory = this.searchData.ProductCategory;
            this.resultData.ProductModel = this.searchData.ProductModel;

            if(this.searchData.DocumentType !== '3' || this.searchData.DocumentType === '3' && this.searchData.Certification === 'all')  
            //不选Certification 或者 选了Certification并且选了all
                this.resultData.DocumentType = this.searchData.DocumentType; 
            else   //选Certification
                this.resultData.DocumentType = this.searchData.Certification;
                
            this.updateList++;
        }
    },
    computed: {},
    watch:{
        'searchData.ProductCategory'() {
            this.$http.get("getAllDocumentsProductModel",{CategoryID:this.searchData.ProductCategory},(data)=>{
                this.productModelList = data.data;
               this.productModelList.unshift({ProductModel:"all"});
            });
            
        },
        'searchData.DocumentType'() {
            if(this.searchData.DocumentType==="3") {
                this.isCertificationBlock=true;

            }
            
        }
    }      
};
</script>
